import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ScheduleIcon from '@mui/icons-material/Schedule';
import GroupsIcon from '@mui/icons-material/Groups';
import SettingsIcon from '@mui/icons-material/Settings';
import PersonIcon from '@mui/icons-material/Person';
import ChevronRightIcon from '@mui/icons-material/ChevronRight'

import { useHistory } from 'react-router-dom';

const UserSidebar = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();

    const operatorTeam = useSelector(state => state.team.selectedTeam);
    const user = useSelector(state => state.auth.user);
    const [isAvailable, setIsAvailable] = useState(true);

    const handleGameLog = () => {
        history.push('/gamelog');
    };

    const handleTeamsAndRoster = () => {
        history.push('/myteam');
    };
    const handleOpponents = () => {
        history.push('/opponents');
    };

    const handleTeamSettings = () => {
        history.push('/settings');
    };
    const handleAccountSettings = () => {
        history.push('/accountsettings');
    };

    return (
        <div>
            {/* Sidebar */}
            <div className='sidebarDashboard'>
                <div className="sidebarHeader">
                    <p className="handwritten">Welcome</p>
                    <p className='userTeamNameSide'> {operatorTeam?.teamId?.teamName}</p>
                </div>

                <ul className="sidebarMenu">
                    <li onClick={handleGameLog} className="menuItem">
                        <ScheduleIcon className="menuIcon" />
                        <span>Game Results</span>
                        <ChevronRightIcon className="arrowIcon" />
                    </li>
                    <li onClick={handleTeamsAndRoster} className="menuItem">
                        <GroupsIcon className="menuIcon" />
                        <span>Teams and Roster</span>
                        <ChevronRightIcon className="arrowIcon" />
                    </li>
                    <li onClick={handleOpponents} className="menuItem">
                        <GroupsIcon className="menuIcon" />
                        <span>Opponents and Roster</span>
                        <ChevronRightIcon className="arrowIcon" />
                    </li>
                    <li onClick={handleTeamSettings} className="menuItem">
                        <SettingsIcon className="menuIcon" />
                        <span>Team Settings</span>
                        <ChevronRightIcon className="arrowIcon" />
                    </li>
                    <li onClick={handleAccountSettings} className="menuItem">
                        <PersonIcon className="menuIcon" />
                        <span>Account Settings</span>
                        <ChevronRightIcon className="arrowIcon" />
                    </li>
                </ul>

            </div>
        </div>
    );
};

export default UserSidebar;


